
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightLanternPort as ObiLightLanternPortElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-lantern-port.js';
 
 
 

 
 export const ObiLightLanternPort = createComponent({
   react: React,
   tagName: 'obi-light-lantern-port',
   elementClass: ObiLightLanternPortElement,
   events: {
     
   }
  });
 
 